<dx-select-box [value]="team"
               (valueChange)="teamChange.emit($event)"
               [dataSource]="dataSource"
               [disabled]="disabled"
               [showClearButton]="!required"
               displayExpr="name"
               [searchEnabled]="true"
               [grouped]="grouped"
               [searchExpr]="$any('name')"
               placeholder="Select group..."
               itemTemplate="itemTemplate"
               data-test="select-team">
    <div *dxTemplate="let team of 'itemTemplate'"
         class="ps-0 select-team-box-team">
        <adapt-link-team [team]="team"
                         [showIcon]="showIcon"
                         [smallIcon]="true"
                         [adaptLinkDisabled]="true"></adapt-link-team>
    </div>
    <div *dxTemplate="let group of 'group'">
        {{ group.key.slice(group.key.indexOf("_") + 1) }}
    </div>
</dx-select-box>
